import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import image from '../assets/Logo.jpg';
import Basic from "../assets/Basic Mobile Repairing.webp";
import Advanced from '../assets/Advanced Mobile Training.webp';
import ChipLevel from '../assets/Chip-Level Training.webp';
import { Link } from "react-router-dom";

function Service() {
    return (
        <>
            {/* Contact Info - Email (Left) & Phone (Right) */}
            <div className="d-flex flex-wrap justify-content-between align-items-center p-2 px-3 bg-light">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2 text-orange" />
                    <span className="fw-bold">ultramobiles07@gmail.com</span>
                </div>
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faPhone} className="me-2 text-orange" />
                    <span className="fw-bold">9994141075</span>
                </div>
            </div>
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container d-flex justify-content-between align-items-center">
                    {/* Logo and Institute Name */}
                    <div className="d-flex align-items-center">
                        <Link className="navbar-brand" to="/">
                            <img src={image} className="d-block" style={{ width: "70px" }} alt="Ultramobiles" />
                        </Link>
                        <div className="brand-title ms-2">Ultra Mobiles Training Institute</div>
                    </div>

                    {/* Navbar Toggle Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Navbar Links */}
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item"><Link className="nav-link" to="/">Home</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/course">Course</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/about">About</Link></li>
                            <li className="nav-item"><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Service Cards Section */}
            <div className="container mt-5">
                <div className="row justify-content-center">

                    {/* Basic Mobile Repairing */}
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm">
                            <div className="card-body text-center">
                                <h5 className="card-title" style={{ color: 'orange' }}>Basic Mobile Repairing</h5>
                                <img src={Basic} className="img-fluid" alt="Basic Mobile Repairing" style={{ maxWidth: "100%", height: "auto", borderRadius: "5px" }} />
                                <p className="card-text mt-2" style={{ textAlign: 'justify' }}>
                                    The Basic Mobile Service Training course is designed for beginners who want to learn essential skills in mobile phone repair and servicing. This training provides fundamental knowledge about mobile phone hardware and software, common troubleshooting techniques, and repair methods for basic issues.
                                </p>
                                <h5 style={{ color: 'orange' }}>What You Will Learn:</h5>
                                <ul style={{ textAlign: 'justify' }}>
                                    <li>Introduction to mobile phone components and tools</li>
                                    <li>Identifying and fixing common hardware and software problems</li>
                                    <li>Battery, speaker, microphone, and charging port replacements</li>
                                    <li>Basic soldering and component handling techniques</li>
                                    <li>Understanding mobile operating systems and software troubleshooting</li>
                                    <li>Safety measures and best practices in mobile repair</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Advanced Mobile Repairing */}
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm">
                            <div className="card-body text-center">
                                <h5 className="card-title" style={{ color: 'orange' }}>Advanced Mobile Repairing</h5>
                                <img src={Advanced} className="img-fluid" alt="Advanced Mobile Repairing" style={{ maxWidth: '100%', height: "auto", borderRadius: '5px' }} />
                                <p className="card-text mt-2" style={{ textAlign: 'justify' }}>
                                    The Advanced Mobile Service Training course is designed for individuals who already have a basic understanding of mobile phone repair and want to enhance their skills to handle complex issues. This course covers in-depth troubleshooting, advanced hardware and software repairs, and techniques to fix modern smartphones, including flagship models.
                                </p>
                                <h5 style={{ color: 'orange' }}>What You Will Learn:</h5>
                                <ul style={{ textAlign: 'justify' }}>
                                    <li>Advanced hardware troubleshooting for flagship devices</li>
                                    <li>Micro-soldering and precision repair techniques</li>
                                    <li>Screen, display, and touch panel replacement for high-end phones</li>
                                    <li>Water-damage diagnosis and repair</li>
                                    <li>Software flashing, unlocking, and IMEI repairing</li>
                                    <li>Motherboard IC reballing and chipset-level repair</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Chip-Level Training */}
                    <div className="col-md-4 mb-4">
                        <div className="card shadow-sm">
                            <div className="card-body text-center">
                                <h5 className="card-title" style={{ color: 'orange' }}>Chip-Level Training</h5>
                                <img src={ChipLevel} alt='Chip-Level Training' className="img-fluid" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                <p className="card-text mt-2" style={{ textAlign: 'justify' }}>
                                    The Chip-Level Training course is designed for those who want to specialize in advanced circuit and motherboard repairs. This training focuses on diagnosing and fixing chip-level issues in mobile devices.
                                </p>
                                <h5 style={{ color: 'orange' }}>What You Will Learn:</h5>
                                <ul style={{ textAlign: 'justify' }}>
                                    <li>Understanding PCB layouts and circuit diagrams</li>
                                    <li>Diagnosing and replacing faulty IC components</li>
                                    <li>Micro-soldering and hot air rework techniques</li>
                                    <li>EEPROM programming and BIOS chip repair</li>
                                    <li>Power section troubleshooting and short-circuit fixing</li>
                                    <li>Flashing, unlocking, and bootloader repair</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Footer Section */}
            <footer style={{ backgroundColor: "orange", color: "white", textAlign: "center", padding: "15px", marginTop: "20px" }}>
                <p className="mb-0">COPYRIGHT © 2025 Ultramobiles Training Institute. All Rights Reserved.</p>
            </footer>
            <style>
                {`
                    .brand-title {
                        font-weight: bold;
                        font-size: 1.3rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    @media (max-width: 768px) {
                        .brand-title {
                            font-size: 1.1rem;
                            text-align: center;
                            padding-top: 5px;
                        }
                    }

                    @media (max-width: 480px) {
                        .brand-title {
                            font-size: 1rem;
                            white-space: normal; /* Allow text to wrap */
                            text-align: left;
                        }
                    }

                    @media (max-width: 320px) {
                        .brand-title {
                            font-size: 0.9rem; /* Reduce text size */
                            white-space: normal;
                            text-align: left;
                        }
                    }

                    .text-orange { color: orange; }
                    .bg-orange { background: orange; }
                `}
            </style>

        </>
    );
}

export default Service;
